export default __webpack_public_path__ + "static/media/line_verticle.48d994d1.svg";